import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Spinner } from 'reactstrap'

import { getPrimaryEmailAddress } from 'models/ProfileInfo/selectors'
import { STRING } from 'resources'
import { rightArrowIconWhite } from 'resources/images'
import { getReklaimProtectSubscriptionData } from 'services/reklaimProtect'

import {
  SpinnerContainer,
  Card,
  CardContentContainer,
  TitleContainer,
  CardTitle,
  StatusText,
  CardSubTextContainer,
  WhiteClockIcon,
  CardSubText,
  PurpleCardSubText,
  Line,
  LinkContainer,
  CardSubTextArrowIcon,
} from './styles'

const ReklaimProtectSubscriptionStatusCard = ({ setSubscriptionStatus }) => {
  const primaryEmailAddress = useSelector(getPrimaryEmailAddress)
  const [subscriptionData, setSubscriptionData] = useState(null)

  const fetchSubscriptionData = useCallback(async () => {
    const protectSubscriptionData = await getReklaimProtectSubscriptionData(primaryEmailAddress)
    const eventPayload = protectSubscriptionData?.eventPayload
    if (eventPayload) {
      setSubscriptionStatus(eventPayload)
    }
    setSubscriptionData(protectSubscriptionData)
  }, [primaryEmailAddress, setSubscriptionData, setSubscriptionStatus])

  useEffect(() => {
    fetchSubscriptionData()
  }, [fetchSubscriptionData])

  return (
    <Card>
      <CardContentContainer>
        <TitleContainer>
          <CardTitle>{STRING.protect.subscriptionStatus.title}</CardTitle>
          <CardTitle>
            {subscriptionData?.statusLabel ? (
              <StatusText>{subscriptionData.statusLabel}</StatusText>
            ) : (
              <SpinnerContainer>
                <Spinner color="light" />
              </SpinnerContainer>
            )}
          </CardTitle>
        </TitleContainer>
        <CardSubTextContainer>
          <WhiteClockIcon />
          <CardSubText>
            {subscriptionData?.daysRemainingLabel
              ? subscriptionData.daysRemainingLabel
              : STRING.protect.subscriptionStatus.daysRemaining.endsIn}
            <PurpleCardSubText>{subscriptionData?.daysRemaining}</PurpleCardSubText>
          </CardSubText>
        </CardSubTextContainer>
        {subscriptionData?.linkLabel && subscriptionData?.link && (
          <>
            <Line />
            <LinkContainer href={subscriptionData.link} target="_blank" rel="noopener noreferrer">
              <CardSubText>{subscriptionData.linkLabel}</CardSubText>
              <CardSubTextArrowIcon src={rightArrowIconWhite} resizeMode="contain" />
            </LinkContainer>
          </>
        )}
      </CardContentContainer>
    </Card>
  )
}

ReklaimProtectSubscriptionStatusCard.propTypes = {
  setSubscriptionStatus: PropTypes.func.isRequired,
}

export default ReklaimProtectSubscriptionStatusCard
